/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, createRef } from "react";
import { MapContainer, TileLayer, LayersControl, ZoomControl, LayerGroup, Marker, Popup, Polyline} from "react-leaflet";
import { divIcon } from "leaflet";
import "./LeafletOneatlas";
import "leaflet/dist/leaflet.css";
import DataTable from './DataTable';
import { Button } from '@mui/material';
import "./LeafletOneatlas";
import '@tomtom-international/web-sdk-maps/dist/maps.css'
import { WMSTileLayerWithHeader } from "./WMSTileLayerWithHeader";
import { FeatureLayer } from "react-esri-leaflet";


// import { ENV } from '../../dev-env.js';
// const WMTSTileLayer = import ('https://rawgithub.com/mylen/leaflet.TileLayer.WMTS/master/leaflet-tilelayer-wmts.js');
const AIRBUS_KEY = process.env.AIRBUS_KEY || 'oHr2RGT2FCMGseNjD_lxtyvqzgtOBzP_Dobsf9W60pCBiGK0Vv24tvHFH0_2Xd5mOLirCwoV9qeiyB1L20J2zw==';
const ESRI = 'AAPK5724c9a3480140a8a4514357e938051fAqSQNP6KCXws2MlczxGR_cH7jb3Zhuoldyn8jAzLRLmd2z_bYNeNnye_syfb65dS';

//class component exports map 
class LeafletMap extends Component {

	constructor(props) {
		super(props);
		//state props
		this.state = {
			loadView: { lat: -25.878078, lng: 28.168741 },
			zoomLevel: 5,
			latitude: '',
			longitude: '',
			L:window.L,
			viewName: '',
			getRoute: true,
			estimated_travel_time:'',
			origin: '',
			data: [],
			data2: [],
			destination: '',
			line: [],
			coordCount: 1,
			result_data: [],
			clear: false,
			tableName: '',
			submit: '',
			urlCall: '',
			routeInstructions: [],
			tokenTimeout: 0,
			accessToken:'',
			tokenTimestamp: 0,
			airbus_key: AIRBUS_KEY,
			markers: [],
			popupContent: [],
			snapToRoadResult: [],
			snapToRoadGeom: [],
			snapToRoadHolder: ''
		}
		// bind methods that will change state prop values
		this.dataLaunch = this.dataLaunch.bind(this);
		this.searchMyLocation = this.searchMyLocation.bind(this);
		this.searchMyDestination = this.searchMyDestination.bind(this);
		this.routing = this.routing.bind(this);
		this.checkRoute = this.checkRoute.bind(this);
		this.clearTable = this.clearTable.bind(this);
		this.trackLat = this.trackLat.bind(this);
		this.trackLon = this.trackLon.bind(this);
		this.submitChange = this.submitChange.bind(this);
		this.getRouteSwitch = this.getRouteSwitch.bind(this);
		this.mapRef = createRef();
		this.getNewToken = this.getNewToken.bind(this);
		this.dropPinAtSearched = this.dropPinAtSearched.bind(this);
		this.snapToRoad = this.snapToRoad.bind(this);
		this.addSNR = this.addSNR.bind(this);
		this.changePos = this.changePos.bind(this);
	}

	// show page one on load
	componentDidMount() {

		this.setState({
			viewName: 'page1'
		});

		// this.map = tt.map({

        //     key: APIKEY,
        //     container: 'map2',
        //     language: 'en-GB',
        //     center: [28.31339534205034, -25.75112170051615],
        //     zoom: 8,
        //     pitch: 0,
        //     stylesVisibility: {
        //         trafficIncidents: true,
        //         trafficFlow: true,
        //         points: true
        //     },
        //     fadeDuration: 250,
        // })

		// this.getNewToken()
	}


	// this method is called when the 'get route' button is clicked
	checkRoute(e) {

		// if the orgin and destination state values (these are bound to the loation inputs on the route page) 
		// are not of length 0...
		if (this.state.origin.length > 0 && this.state.destination.length > 0) {

			console.log(this.state.data[0].position);
			console.log(this.state.data2[0].position);
			// set the start and end positions (using the coords)
			var start = this.state.data[0].position;
			var end = this.state.data2[0].position;
			// and then use these values to call the routing method
			this.routing(start, end, "green");
		}
	}

	// this method is called when the 'reset table' button is clicked
	clearTable(e) {

		var clear = this.state.clear;

		this.setState({
			clear: clear === !clear
		});

		this.setState({
			latitude: ''
		});

		this.setState({
			longitude: ''
		});

		this.setState({
			tableName: ''
		})

		this.setState({
			submit: 'ready'
		});

		this.setState({
			result_data: []
		})

		this.setState({
			urlCall: ''
		})

		this.setState({
			routeInstructions: []
		})

		this.setState({
			getRoute: true
		})
	}

	// this method is uses the origin input to send a request to Tomtom's routing api
	searchMyLocation(e) {
		var placename = e.target.value;
		this.setState({
			origin: placename
		});

		if (placename.length > 0) {
			fetch("https://api.tomtom.com/search/2/search/"+placename+".json?typeahead=true&limit=6&countrySet=zaf&key=eYcMZC3yQCZRHa0fzBhRgQQPeGi3J4OS", {
					headers: {
						'Content-Type': 'application/json'
					}
				})
			.then(res => res.json())
			.then((data) => {
				this.setState({
					data: data.results
				})
			})
		}
	}

	// this method is uses the destination input to send a request to Tomtom's search api
	searchMyDestination(e){
		var placename2 = e.target.value;
		var mainContent = []
		this.setState({
			destination: placename2
		});


		if (placename2.length > 0) {
			fetch("https://api.tomtom.com/search/2/search/"+placename2+".json?typeahead=true&limit=6&countrySet=zaf&key=eYcMZC3yQCZRHa0fzBhRgQQPeGi3J4OS", {
					headers: {
						'Content-Type': 'application/json'
					}
				})
			.then(res => res.json())
			.then((data) => {
				this.setState({
					data2: data.results
				})
			})
		}
	}

	dropPinAtSearched() {

		let data = this.state.data2;
		let mainContent = [];

		this.setState({
			markers: [data[0].position.lat, data[0].position.lon],
			loadView: {lat: data[0].position.lat, lng: data[0].position.lon},
			zoomLevel: 16
		});



		// console.log(data[0]);

		data.map((data) => {
			return mainContent.push(data.address)
		});

		// console.log(mainContent);
		
		this.setState({
			popupContent: mainContent
		})
	}

	changePos (pos) {
		this.setState({
			loadView: pos
		});
	}

	// this method is called when the user selects an item from the nav menu
	// the selected viewName changes the page that is rendered
	dataLaunch (e) {
	
		var currBtn = e.currentTarget.id;

		this.setState({viewName: currBtn});
	}

	// reset route on "reset table" click
	getRouteSwitch (e) {

		let yayOrNayForRoute = this.state.getRoute

		this.setState({getRoute: !yayOrNayForRoute})
	}

	

	// routing method
	// sends the request to Tomtoms routing api
	async routing(start,end,color){

		var estimated_travel_time =this.state.estimated_travel_time;
		let routeInstructions = ''
		let getRoute = this.state.getRoute

		if (getRoute) {

			let timeElapsed;
			let start_time = new Date().getTime();

			const ttRouteRequest = fetch("https://api.tomtom.com/routing/1/calculateRoute/"+start.lat+","+start.lon+":"+end.lat+","+end.lon+"/json?instructionsType=text&language=english&computeBestOrder=true&routeRepresentation=polyline&computeTravelTimeFor=all&routeType=fastest&traffic=true&avoid=unpavedRoads&travelMode=car&vehicleEngineType=combustion&key=eYcMZC3yQCZRHa0fzBhRgQQPeGi3J4OS")

			let tteRouteResponse = await ttRouteRequest

			let routeData = await tteRouteResponse.json()

			console.log(routeData)

			timeElapsed = (new Date().getTime() - start_time).toString()

			// let points_data = routeData.routes[0].legs[0].points;

			let travel_distance = (routeData.routes[0].summary.lengthInMeters / 1000).toFixed(1);
				
			let travel_time = routeData.routes[0].summary.travelTimeInSeconds;

			var seconds = parseInt(travel_time, 10);

			var hrs   = Math.floor(seconds / 3600);
				seconds  -= hrs*3600;
				var mnts = Math.floor(seconds / 60);
				seconds  -= mnts*60;

			if(hrs===0){
				estimated_travel_time = travel_distance+"KM "+mnts+"min"
				
			}else{
				
				estimated_travel_time = travel_distance+"KM "+hrs+"hrs: "+mnts+"min"				
			}
			
			alert(`ETA: ${estimated_travel_time}`)
			
			let instructionGroups = routeData.routes[0].guidance.instructionGroups

			let instructions = instructionGroups.map((instruction, idx) => {
				
				
				return routeInstructions.concat(`${idx}: ${instruction.groupMessage}`)
			})

			console.log(routeInstructions)
			let indexedData = [{id: (Math.random()).toString(), actual_time: timeElapsed, route_results: instructions}]


			this.setState({
					result_data: [...this.state.result_data, indexedData]
				});

			// console.log(routeData)
			console.log(timeElapsed)

			this.setState({
				line: [...this.state.line, ]

			})

			this.setState({
				getRoute: false
			})

			this.setState({
				tableName: 'routing'
			})
		}
	}

	// this function is called as a trigger when clicking on either hrg submit buttons
	// its main purpose is to fetch the relevant reverse geocode information from its respective api
	async submitChange(e) {

		var targetId = e.currentTarget.id;
		var coord = {lat: this.state.latitude, lon: this.state.longitude}
		var submit = this.state.submit;
		 
		// if the ID of the button clicked is 'rg-btn' and the state of submit is 'ready'
		if(targetId === 'rg-btn' && submit === "ready") {
			// set urlCall state value to DO hrg query string
			this.setState({
				urlCall: `https://api.maps.geoint.africa/v2/FSQNHssAPh7M6cCNv467XtfpCaUV4RFLjFyMe2p2/rg?verbose=2&lat=${coord.lat}&lon=${coord.lon}`
			});
			
			// instatiate time keepers 
			let timeElapsed;
			let start_time = new Date().getTime();
			
			try {
				// post request to API using fetch (note this is set to local proxy)
				const getDDSResponse = fetch('/api/dorg', {
					method: 'POST',
					body:JSON.stringify({lat: coord.lat, lon: coord.lon}),
					headers:{
	                	'Content-Type': 'application/json'
	                }
				})
				
				const ddsRresponse = await getDDSResponse
				let data = await ddsRresponse.json()
				// get time elapsed for request
				timeElapsed = (new Date().getTime() - start_time).toString()
	
				// here we index the data that we need, in the format that is accepted by the MUI Datagrid elements 
				let indexedData = [{id: (Math.random()).toString(), actual_time: timeElapsed, addresses: `country: ${data.addresses[0].address.country} | countryCodeISO3: ${data.addresses[0].address.countryCodeISO3} | countrySecondarySubdivision: ${data.addresses[0].address.countrySecondarySubdivision} | countrySubdivision: ${data.addresses[0].address.countrySubdivision} | freeFormAddress: ${data.addresses[0].address.freeFormAddress} | localNames: ${data.addresses[0].address.localNames} | postalCode: ${data.addresses[0].address.postalCode} | street: ${data.addresses[0].address.street} | streetName: ${data.addresses[0].address.streetName} | speedLimit: ${data.addresses[0].address.speedLimit} | town_or_municipality: ${data.addresses[0].address.town_or_municipality} | position: ${data.addresses[0].position} | road_distance_m: ${data.road_distance_m}`,  summary: data.summary.queryTime}];
	
				// results data is set to indexData value which will be used to populate the results tables for hrg
				this.setState({
						result_data: [...this.state.result_data, indexedData]
					});
	
				// changes the table name to identify which table of results tp show 
				this.setState({
					tableName: "reverse-geocode"
				})
			} catch (error) {
				console.error(error);
			}
			
		}
		// follow then same procedure as above if the ID of the button clicked is 'hrg-btn'
		else if(targetId === 'hrg-btn' && submit === "ready") {

			this.setState({
				urlCall: `https://geofusionapi.geoint.africa/hrg/v1.0/rg?lat=${coord.lat}&lon=${coord.lon}&verbose=2&api_key=FSQNHssAPh7M6cCNv467XtfpCaUV4RFLjFyMe2p2`
			});

			let timeElapsed;
			let start_time = new Date().getTime();

			try {
				const getHrgResponse = fetch('/api/hrg', {
					method: 'POST',
					body:JSON.stringify({lat: coord.lat, lon: coord.lon}),
					headers:{
	                	'Content-Type': 'application/json'
	                }
				})
			
				const hrgRresponse = await getHrgResponse
	
				let data = await hrgRresponse.json()
				
				timeElapsed = (new Date().getTime() - start_time).toString()
	
				let indexedData = [{id: (Math.random()).toString(), actual_time: timeElapsed, addresses: `country: ${data.addresses[0].address.country} | countryCodeISO3: ${data.addresses[0].address.countryCodeISO3} | countrySecondarySubdivision: ${data.addresses[0].address.countrySecondarySubdivision} | countrySubdivision: ${data.addresses[0].address.countrySubdivision} | freeFormAddress: ${data.addresses[0].address.freeFormAddress} | localNames: ${data.addresses[0].address.localNames} | postalCode: ${data.addresses[0].address.postalCode} | street: ${data.addresses[0].address.street} | streetName: ${data.addresses[0].address.streetName} | speedLimit: ${data.addresses[0].address.speedLimit} | town_or_municipality: ${data.addresses[0].address.town_or_municipality} | position: ${data.addresses[0].position} | road_distance_m: ${data.road_distance_m}`,  summary: data.summary.queryTime}];
	
				this.setState({
						result_data: [...this.state.result_data, indexedData]
					});
	
				this.setState({
					tableName: "hyper-reverse-geocode"
				})
			} catch (error) {
				console.error(error);
			}
			
		}
		else if(this.state.submit === ''){

			alert('Please reset table before submitting')
		}
	}

	// track value of latitude input on hrg tab and set value to state prop 'latitude' to be made available for use elsewhere
	trackLat(e) {
	
		this.setState({
			latitude: e.target.value
		})
	}

	// track value of longitude input on hrg tab and set value to state prop 'latitude' to be made available for use elsewhere
	trackLon(e) {
		this.setState({
			longitude: e.target.value
		})
	}

	async getNewToken() {
		var airbusUrl = `https://authenticate.foundation.api.oneatlas.airbus.com/auth/realms/IDP/protocol/openid-connect/token`;
		let thePayLoad = `grant_type=api_key&apikey=${AIRBUS_KEY}&client_id=IDP`;
		// apikey=<api_key>&grant_type=api_key&client_id=IDP

		try {
			fetch(airbusUrl, {
				method:'POST',
				headers: {
					"Content-Type": "application/x-www-form-urlencoded"
				},
				body: thePayLoad
			})
			.then((response) => {return response.json()})
			.then((result) => {
				this.setState({
					accessToken: result.access_token
				})
	
				// console.log(result.access_token)
			})
			.catch((error) => {
				console.error(error.message)
			});
		} catch (error) {
			console.error(error.message)
		}
	}

	async snapToRoad(e) {

		let lineList = [];
		let reversedLineList = [];
		let snapToRoadInput = this.state.snapToRoadHolder;

		console.log(snapToRoadInput);

		try {
			
			fetch('/api/snaptoroad', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({coords: snapToRoadInput})
			})
			.then((response) => response.json())
			.then((data) => {



				console.log(data);
				let routes = data.route

				routes.map((line, index) => {

					return lineList.push(line.geometry.coordinates)
				})

				lineList.map((points, pointIndex)=>{
					let point = points.map(point => {
						return point.reverse()
					})
					return reversedLineList.push(point)
				})

				this.setState({
					snapToRoadResult: reversedLineList
				})
				
				console.log(lineList);
			})

		} catch (error) {
			console.error(error.message);
		}
	}

	addSNR(e) {

		this.setState({
			snapToRoadHolder:e.target.value
		})
	}

	render() {
		//state to variables
		const { 
			loadView, zoomLevel, viewName, data, data2, latitude, longitude, 
			accessToken, tokenTimeout, result_data, tableName, urlCall} = this.state;

		// columns for DO hrg results table
		const columnsRg = [
			{field: 'id', headerName: 'ID', width: 50},
			{field: 'summary', headerName: 'Query Time (s)', width: 170},
			{field: 'actual_time', headerName: 'Full Time Elapsed (ms)', width: 170},
			{field: 'addresses' , headerName: 'Address Information', width: 700, align: 'left'}
		];

		// columns for Huawei hrg results table
		const columnsHrg = [
			{field: 'id', headerName: 'ID', width: 50},
			{field: 'summary', headerName: 'Query Time (s)', width: 170},
			{field: 'actual_time', headerName: 'Full Time Elapsed', width: 180},
			{field: 'addresses' , headerName: 'Address Information', width: 700},
		];

		// columns for routing results table
		const columnsRoute = [
			{field: 'id', headerName: 'ID', width: 50},
			{field: 'actual_time', headerName: 'Full Time Elapsed (ms)', width: 180},
			{field: 'route_results' , headerName: 'Route Results', width: 700},
		];
		
		// styling for datagrid
		const deployTableStyles = {
			textAlign: 'left',
			height: 450,
			width: '65%',
			right: '-30%',
			boxShadow: 2,
			border: 2,
			borderColor: 'primary.light',
			'& .MuiDataGrid-cell:hover': {
				color: 'primary.main'
			}
		}

		// Map Layers
		const Satellite = 'http://159.138.174.4/:7022//basemap/wmts?style=default&service=WMTS&version=1.0.0&layer=advancedBasemap&tilematrixSet=3857&format=image%2Fjpeg&request=GetTile&tilematrix={z}&tilerow={y}&tilecol={x}&key=FSQNHssAPh7M6cCNv467XtfpCaUV4RFLjFyMe2p2'
		const esri = `https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=${ESRI}`
		const TT_Street = 'https://api.tomtom.com/map/1/tile/basic/main/{z}/{x}/{y}.png?tileSize=256&view=Unified&language=NGT&key=qu6eef0BAgydDTJAiZWaCjWRTEhFC7ky'
		const Transparent = 'https://api.maps.geoint.africa/v1/tile/{x}/{y}/{z}.png?settings=decarta_tt_transparent_hdpi'
		const TT_Satellite = 'https://b.api.tomtom.com/map/1/tile/sat/main/{z}/{x}/{y}.jpg?key=qu6eef0BAgydDTJAiZWaCjWRTEhFC7ky'
		const { BaseLayer } = LayersControl;
		// const Satellite = 'https://api.tomtom.com/map/1/tile/sat/main/{z}/{x}/{y}.jpg?tileSize=256&key=qu6eef0BAgydDTJAiZWaCjWRTEhFC7ky'

		// 'https://view-bm.api.oneatlas.airbus.com/basemap/wmts?SERVICE=WMTS&REQUEST=GetCapabilities' --header 'Authorization: Bearer <ACCESS TOKEN≥'

		const purpleOptions = { color: 'purple' }

		// set timeout for token renewal - 58 minutes
		if(tokenTimeout === 3600) {
			setTimeout(this.getNewToken, 3480000)
		}

		const customIcon = divIcon({
			html: "<img className='pinPoint' src='placeholder.png' alt='Icon' size='small' style={{height: '20px', width: '20px'}}></img>",
		})

		if(viewName === 'page2') {
			return (
				<div>
					<div style={{position: 'absolute'}}>
						<div className="hamburger-menu">
							<input id="menu__toggle" type="checkbox" />
							<label className="menu__btn" for="menu__toggle">
							<span></span>
							</label>
							
							<ul className="menu__box">
								{/* <li><a className="menu__item" href="/" >Home</a></li> */}
								<li style={{cursor: 'pointer'}} ><a id="page1" className="menu__item" data-launch-view="page1" onClick={this.dataLaunch}>Map Visualization</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page2" className="menu__item" data-launch-view="page2" onClick={this.dataLaunch}>Reverse Geocoding</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page3" className="menu__item"  data-launch-view="page3" onClick={this.dataLaunch}>Routing</a></li>
							</ul>
						</div>
					</div>
					<div className="container-fluid" style={{marginTop: 20}}>
						<div className="row" >
							<div className="search_wrap col-sm-4 col-md-4 col-lg-5" id="search_wrap_wrap" style={{alignContent: 'start'}}>
							
							<input 
									className="form-control input_search" 
									id="input_search"
									style={{marginTop: '40px', padding: '4px'}}
									type="text" 
									name="search" 
									placeholder="  Enter latitude e.g(-26.26962)"
									onChange={this.trackLat}
									value={latitude}
									/>
								<div className="location_wrap col-sm-4 col-md-4 col-lg-5" id="location_wrap">
									<input 
										className="form-control input_location" 
										style={{marginTop: '40px', padding: '4px'}}
										id="input_location" 
										type="text" 
										name="search2" 
										placeholder="  Enter longitude e.g(27.97572)"
										onChange={this.trackLon}
										value={longitude}
									/>
								</div>
								<div className="button_wrap col-sm-4 col-md-4 col-lg-5" id="button_wrap">
									<button 
										className="btn btn-success" 
										onClick={this.submitChange} 
										id="rg-btn"
										style={{marginBottom: '15px', marginTop: '30px'}}
									>
										Hyper-Reverse Geocode
									</button>
									{/* <button 
										className="btn btn-alert" 
										onClick={this.submitChange}  
										id="hrg-btn"
									>
										Huawei Hyper-Reverse Geocode
									</button> */}
								</div>
								
							</div>
						</div>
						<div className="row">
							<div className="col-sm-4 col-md-4 col-lg-5" id="tabel_container">
							
                            	<h3 style={{color: "#282c34"}}>API Results</h3>
								<></>
								<Button
										sx={{ width: 270,}}
										onClick={this.clearTable}
									>Reset Table
								</Button>
								{tableName==="reverse-geocode" ?
									<DataTable
										rows={result_data[0]}
										columns={ columnsRg }
										sx={deployTableStyles}		 
									/>
									:	tableName==="hyper-reverse-geocode" ?
									<DataTable
										rows={result_data[0]}
										columns={ columnsHrg }
										sx={deployTableStyles}
									/>
									: <></>
						   		}
								
							</div>
						</div>
						{urlCall.length > 0 ? (<h5 id="urlString" style={{color:'slategray', marginLeft: '23%'}}>{urlCall}</h5>) : null}
					</div>
				</div>
			)
		}
		else if(viewName === 'page3') {
			return (
				<div>
					<div style={{position: 'absolute'}}>
						<div className="hamburger-menu">
							<input id="menu__toggle" type="checkbox" />
							<label className="menu__btn" for="menu__toggle">
							<span></span>
							</label>
						
							<ul className="menu__box">
								
								<li style={{cursor: 'pointer'}} ><a id="page1" className="menu__item" data-launch-view="page1" onClick={this.dataLaunch}>Map Visualization</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page2" className="menu__item" data-launch-view="page2" onClick={this.dataLaunch}>Reverse Geocoding</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page3" className="menu__item"  data-launch-view="page3" onClick={this.dataLaunch}>Routing</a></li>
							</ul>
						</div>
					</div>
					<div className="container-fluid">
						<div className="row">
							<div className="search_wrap col-sm-4 col-md-4 col-lg-5" id="search_wrap_wrap" style={{alignContent: 'start'}}>
								<input 
									className="form-control input_search" 
									id="input_search"
									list="destinationText" 
									type="text" 
									name="search" 
									placeholder="  Navigate to"
									onKeyUp={this.searchMyDestination}
									/>
								<datalist id="destinationText">
										{data2.map((destinationItem, idx) => (
											
											<option key={idx} value={destinationItem.address.freeformAddress} />
											
										))}		
								</datalist> 
								<div className="location_wrap col-sm-4 col-md-4 col-lg-5" id="location_wrap">
									<input 
										className="form-control input_location" 
										list="searchText"
										id="input_location" 
										type="text" 
										name="search2" 
										placeholder="  Enter your location"
										onKeyUp={this.searchMyLocation}	
									/>
									<datalist id="searchText">
										{data.map((searchItem, idx) => (
											
												<option key={idx} value={searchItem.address.freeformAddress} />
											
										))}		
									</datalist> 
								</div>
								<div className="button_wrap col-sm-4 col-md-4 col-lg-5" id="button_wrap2">
									<button className="btn btn-success" onClick={this.checkRoute} style={{width: '220px', height: '40px', borderRadius: '4px'}}>Get Route</button>
									
								</div>

							</div>
						</div>
						<div className="row">
							<div className="col-sm-4 col-md-4 col-lg-5" id="tabel_container">
							
								<h3 style={{color: "#282c34"}}>Route API Results</h3>
								<></>
								<Button
										sx={{ width: 270,}}
										onClick={this.clearTable}
									>Reset Table
								</Button>
								{tableName==="routing" ?
									<DataTable
										rows={result_data[0]}
										columns={ columnsRoute }
										sx={deployTableStyles}		 
									/>
									: <></>
								}
								
							</div>
						</div>
						
						{urlCall.length > 0 ? (<h4 id="urlString" style={{color:'slategray', marginLeft: '23%'}}>{urlCall}</h4>) : null}
					</div>
						<div className="clearfix"> </div>

					<div className="eta col-md-8" id="eta"> 
						<span id="time"></span>
						<table />
					</div>
				</div>
			)
		}

		else if (viewName === "page1") {
			return (
				<div id="map-visualization">
					<MapContainer center={[loadView.lat, loadView.lng]} zoom={zoomLevel} zoomControl={false}>
						<div 
							id="search_wrap_wrap" 
							style=
								{{
									alignContent: 'start', 
									zIndex:999, 
									position:"absolute",
									marginTop: '8px',
									marginLeft: '8px',
									width: '20vw',
									padding: '8px',
									borderColor: 'gray'
								}}
						>	
							<div data-tip="format: lat,lon;lat,lon;..." style={{marginBottom:"5px"}} >
								<input 
									className="form-control input_search" 
									id="input_search"
									list="destinationText" 
									type="text" 
									name="snaptoroad" 
									placeholder="  Snap to Road"
									onChange={this.addSNR}
								/>
							</div>
							<button 
								type="button" 
								id="searchExecuter"
								style={{
									marginTop: '8px',
									marginBottom: '8px',
									backgroundColor: '#181425',
									color: 'white',
									padding: '8px',
									height: '33px',
									width: '20vw',
									border: '1px solid gray',
									borderRadius: '5px',
								}}
								onClick={this.snapToRoad}
							>
								<b>Snap to Road</b>
							</button>
							
							<input 
								className="form-control input_search" 
								id="input_search"
								list="destinationText" 
								type="text" 
								name="search" 
								placeholder="  Search"
								onKeyUp={this.searchMyDestination}
							/>
							<datalist id="destinationText">
									{data2.map((destinationItem, idx) => (
										
										<option key={idx} value={destinationItem.address.freeformAddress} />
										
									))}		
							</datalist>
							<button 
								type="button" 
								id="searchExecuter"
								style={{
									marginTop: '8px',
									backgroundColor: '#181425',
									color: 'white',
									padding: '8px',
									height: '33px',
									width: '20vw',
									border: '1px solid gray',
									borderRadius: '5px',
								}}
								onClick={this.dropPinAtSearched}
							>
								<b>Fly to Location</b>
							</button>
						</div>
						<ZoomControl position="bottomleft"></ZoomControl>
						{
							this.state.markers.length > 0 ?
								(
									<Marker id='marker' key='marker' position={this.state.markers} icon={customIcon}>
									<Popup>
										<span>
											<b>Location Details</b>
											<hr/>
												<ul>
											
													<li>
														<b>country:</b>{` ${this.state.popupContent[0].country}`}
													</li>
													<li>
														<b>countrySecondarySubdivision:</b>{` ${this.state.popupContent[0].countrySecondarySubdivision}`}
													</li>
													<li>
														<b>countrySubdivision:</b>{` ${this.state.popupContent[0].countrySubdivision}`}
													</li>
													<li>
														<b>freeformAddress:</b>{` ${this.state.popupContent[0].freeformAddress}`}
													</li>
													<li>
														<b>streetName:</b>{` ${this.state.popupContent[0].streetName}`}
													</li>
													<li>
														<b>streetNumber:</b>{` ${this.state.popupContent[0].streetNumber}`}
													</li>
													<li>
														<b>municipality:</b>{` ${this.state.popupContent[0].municipality}`}
													</li>
													<li>
														<b>municipalitySubdivision:</b>{` ${this.state.popupContent[0].municipalitySubdivision}`}
													</li>
													<li>
														<b>postalCode:</b>{` ${this.state.popupContent[0].postalCode}`}
													</li>
													
												</ul>
										</span>
									</Popup> 
									</Marker>
								) :
								<></>
						}
						{
							this.state.snapToRoadResult.length > 0 ? (
								this.state.snapToRoadResult.map((line, idx) => (
									<Polyline key={idx} pathOptions={purpleOptions} positions={line} />
								))
							)
							:
							<></>
						}

						{/* The LayersControl tag help us organize our layers into baselayers and tilelayers */}
						<LayersControl position="topright" >
							<BaseLayer name="Geofusion Street" checked>
								<TileLayer 
									attribution='&copy; <a href="https://geoint.africa/">GeoFusion-DDS Map</a> contributors'
									// url='https://api.maps.geoint.africa/v1/FSQNHssAPh7M6cCNv467XtfpCaUV4RFLjFyMe2p2/tile/{x}/{y}/{z}.png?settings=global-decarta_tt'
									url='https://geofusionapi.geoint.africa/maptile/v1/wGrT1OYDXM7cl9wuUiUoeB26aadDLV88Ye0w93QjF/tile/{x}/{y}/{z}.png?settings=global-decarta_tt'
									>
								</TileLayer>
							</BaseLayer>
							<BaseLayer name="TomTom Street">
								<TileLayer 
									attribution='&copy; <a href="https://geoint.africa/">Tomtom Map</a> contributors'
									// url='https://api.tomtom.com/map/1/tile/basic/main/{z}/{x}/{y}.png?key=eYcMZC3yQCZRHa0fzBhRgQQPeGi3J4OS&language=en-GB'
								    url={TT_Street}
									>
								</TileLayer>
								{/* <div ref={this.mapRef} id="map2" style={{ position: 'relative', height: '90%', borderRadius: '2px' }}>
									
								</div> */}
							</BaseLayer>
							<BaseLayer name="Esri Satellite Proxy" >
								<TileLayer
									attribution='&copy; <a href="https://geoint.africa/">GeoInt-Esri Map</a> contributors'
									url={Satellite}
									minZoom={1}
									maxZoom={23}
									tileSize={256}
									style={{zIndex: 510}}
									>
								</TileLayer>
								
							</BaseLayer>
							<BaseLayer name="ESRI" >
								
								<TileLayer
									attribution='&copy; <a href="https://geoint.africa/">GeoInt Map | ESRI </a> contributors'
									url={esri}
									maxZoom={20}
									tileSize={256}

								>
								</TileLayer> 
								
							</BaseLayer>
							<BaseLayer name="TomTom Satellite" >
								
								<TileLayer
									attribution='&copy; <a href="https://geoint.africa/">GeoInt Map | TomTom </a> contributors'
									url={TT_Satellite}
									maxZoom={20}
									tileSize={256}

								>
								</TileLayer> 
								
							</BaseLayer>
							<LayersControl.Overlay name='Transparent'>
								<LayerGroup>
									<TileLayer
										attribution='&copy; <a href="https://geoint.africa/">GeoInt Map</a> contributors'
										url='https://api.maps.geoint.africa/v1/tile/{x}/{y}/{z}.png?settings=zaf-decarta_tt_transparent_mdpi'
										style={{zIndex: 2}}
									>
									</TileLayer>
								</LayerGroup>
							</LayersControl.Overlay>
							
						</LayersControl>
						
					</MapContainer>
					<div style={{position: 'absolute', zindex: 10}}>
						<div className="hamburger-menu">
							<input id="menu__toggle" type="checkbox" />
							<label className="menu__btn" for="menu__toggle">
							<span></span>
							</label>
						
							<ul className="menu__box" style={{zindex: 10}}>
								{/* <li><a className="menu__item" href="/" >Home</a></li> */}
								<li style={{cursor: 'pointer'}} ><a id="page1" className="menu__item" data-launch-view="page1" onClick={this.dataLaunch}>Map Visualization</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page2" className="menu__item" data-launch-view="page2" onClick={this.dataLaunch}>Hyper Reverse Geocoding</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page3" className="menu__item" data-launch-view="page3" onClick={this.dataLaunch}>Routing</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page4" className="menu__item" data-launch-view="page4" onClick={this.dataLaunch}>Search</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page5" className="menu__item" data-launch-view="page5" onClick={this.dataLaunch}>Geocoding</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page6" className="menu__item" data-launch-view="page6" onClick={this.dataLaunch}>Batch Routing</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page7" className="menu__item" data-launch-view="page7" onClick={this.dataLaunch}>Geofencing</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page8" className="menu__item" data-launch-view="page8" onClick={this.dataLaunch}>O/D Analysis</a></li>
								<li style={{cursor: 'pointer'}} ><a id="page9" className="menu__item" data-launch-view="page9" onClick={this.dataLaunch}>Traffic</a></li>
							</ul>
						</div>
					</div>
				</div>
			);
		}
	}
};

export default LeafletMap;